import { throwError } from "@/lib/throwError";
import axiosConfig from "../axiosConfig";
import * as qs from "qs";

interface DMUserListPayload {
  anchor: number;
  num_before: number;
  num_after: number;
  client_gravatar: boolean;
  allow_empty_topic_name: boolean;
  narrow: Array<{
    negated: boolean;
    operator: string;
    operand: number[];
  }>;
}

interface SendMessagePayload {
  type: string;
  to: (string | number)[];
  content: string;
  topic?: string;
}

interface CreateChannelPayload {
  schemaName: string;
  payload: any;
}

class ZulipServices {
  getUsers = async (): Promise<any> => {
    return await axiosConfig.get("/users");
  };

  getChannelList = async (): Promise<any> => {
    return await axiosConfig.get("/streams");
  };

  getUsersByChannel = async (channelId: string): Promise<any> => {
    return await axiosConfig.get(`/streams/${channelId}/members`);
  };

  getDMUserList = async (DMUserListPayload: DMUserListPayload) => {
    return await axiosConfig.get("/messages", {
      params: DMUserListPayload,
      paramsSerializer: params => {
        return qs.stringify(params, {
          encode: false,
          arrayFormat: "repeat",
        });
      },
    });
  };
  getDirectMessage = async ({ payload }: any): Promise<any> => {
    return await axiosConfig.get("/messages", {
      params: payload,
      paramsSerializer: params => {
        return qs.stringify(params, {
          encode: false,
          arrayFormat: "repeat",
        });
      },
    });
  };

  getChatOfChannel = async ({ chatOfChannelPayload }: any): Promise<any> => {
    return await axiosConfig.get("/messages", {
      params: chatOfChannelPayload,
      paramsSerializer: params => {
        return qs.stringify(params, {
          encode: false,
          arrayFormat: "repeat",
        });
      },
    });
  };

  createChannels = async ({
    schemaName,
    payload,
  }: CreateChannelPayload): Promise<any> => {
    if (!schemaName || !payload) {
      throwError("Schema name and payload are required", "ZulipServices");
    }
    return await axiosConfig.post("/users/me/subscriptions", payload);
  };

  sendDirectMessage = async (payload: SendMessagePayload): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "ZulipServices");
    }

    const formData = new FormData();
    formData.append("type", payload.type);
    formData.append("to", JSON.stringify(payload.to));
    formData.append("content", payload.content);

    return await axiosConfig.post("/messages", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  sendChannelMessage = async (payload: SendMessagePayload): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "ZulipServices");
    }

    const formData = new FormData();
    formData.append("type", payload.type);
    formData.append("to", JSON.stringify(payload.to));
    formData.append("topic", JSON.stringify(payload.topic ?? ""));
    formData.append("content", payload.content);

    return await axiosConfig.post("/messages", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };
}

const instance = new ZulipServices();

export default instance;
